import { Box, Button, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  bgColor17,
  blackColor,
  blackColor26,
  borderTextbox,
  greyColor3,
  greyColor9,
  greyShade36,
  lightOrange06,
  orangeColor01,
  textBtnColor,
  textBtnColorLight,
  whiteColor,
} from "../../configs/styles/muiThemes";
import ShareEarnHeader from "../ShareAndEarn/ShareEarnHeader";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import AffliatePaymentsContent from "./AffliatePaymentsContent";
import GuestRegisterInstructions from "./GuestRegisterInstructions";
import { getAffiliateValidityApi } from "services/api_calls/affiliate/AffiliateApi";
import { getRefRatesByBusinessID } from "redux/affiliate/AffiliateSlice";

function AffiliateProgramsContent({
  matches,
  fetchPendingPayments,
  fetchSettledPayments,
}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { businessName } = useParams();

  const { rellerProfileData, businessAffiliateData, affiliateValidity } =
    useSelector((state) => state.affiliate);
  const { pendingPayments, settledPayments } = useSelector(
    (state) => state.affiliate
  );

  const businessId = sessionStorage.getItem("businessId");
  const userType = sessionStorage.getItem("userType");
  const [showRegisterInstr, setShowRegisterInstr] = useState(false);

  const handleBack = () => {
    navigate(`/${businessName}`);
  };

  const [commissionPercentage, setCommissionPercentage] = useState(0);

  const getAffiliatePercentage = async () => {
    const affiliateCommissionPer = affiliateValidity?.commissionPercentage || 0;
    const businessCommissionPer =
      businessAffiliateData?.businessResellers?.[0]?.affiliatePercentage || 0;

    if (affiliateCommissionPer > 0) {
      setCommissionPercentage(affiliateCommissionPer);
    } else {
      setCommissionPercentage(businessCommissionPer);
    }

    console.log(
      "getAffiliatePercentage_affiliateCommissionPer",
      affiliateCommissionPer
    );
    console.log(
      "getAffiliatePercentage_businessCommissionPer",
      businessCommissionPer
    );

    console.log("getAffiliatePercentage_VALID", affiliateValidity);
    console.log("getAffiliatePercentage_B_PERCENTAGE", businessAffiliateData);
  };

  useEffect(() => {
    getAffiliatePercentage();
  }, [businessAffiliateData, affiliateValidity]);

  return (
    <Box backgroundColor={whiteColor} mt={1}>
      <ShareEarnHeader
        title="Brand Affiliate - Share & Earn"
        handleBackClick={handleBack}
        handleSettingClick={() => {}}
        handleSearchClick={() => {}}
        hideBackBtn
      />

      <Box px={2} pt={1}>
        <Box
          sx={{
            backgroundImage: "url(/./assets/images/affiliates-banner-1.svg)",
            padding: "28px 10px",
            margin: "0px",
            borderRadius: "7px",
            backgroundPosition: "99%",
            backgroundSize: "100% 90%",
            backgroundRepeat: "no-repeat",
            height: "140px",
            boxSizing: "border-box",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            // width: "100%",
          }}
        >
          <Typography
            variant="h6"
            fontSize={14}
            fontWeight={600}
            lineHeight="18px"
            color={whiteColor}
            mb="4px !important"
          >
            Share product links with followers
          </Typography>
          <Typography
            variant="body2"
            fontSize={12}
            fontWeight={500}
            lineHeight="18px"
            color={whiteColor}
          >
            Earn {commissionPercentage}% commission on each purchase
          </Typography>

          <Typography
            variant="body2"
            fontSize={12}
            fontWeight={500}
            sx={styles.costBoText}
            mt="12px"
          >
            {rellerProfileData?.details?.resellerCode}
          </Typography>
        </Box>

        <Box>
          <Typography
            variant="body2"
            fontSize={14}
            fontWeight={600}
            lineHeight="18px"
            color={blackColor}
          >
            Simple 3 ways to Share
          </Typography>

          <Typography
            variant="body2"
            fontSize={11}
            fontWeight={400}
            lineHeight="14px"
            color={blackColor26}
            mt="7px !important"
            mb="4px !important"
          >
            1. Browse our catalog, Share products
          </Typography>
          <Typography
            variant="body2"
            fontSize={11}
            fontWeight={400}
            lineHeight="14px"
            color={blackColor26}
            mt="7px !important"
            mb="4px !important"
          >
            2. Search for a product & Share
          </Typography>
          <Typography
            variant="body2"
            fontSize={11}
            fontWeight={400}
            lineHeight="14px"
            color={blackColor26}
            mt="7px !important"
            mb="4px !important"
          >
            3. Share our store link
          </Typography>

          {/* <Button
            variant='contained'
            sx={styles.exploreBtn}
            onClick={() => {
              navigate(`/${businessName}/catalog`)
            }}
          >
            EXPLORE & SHARE - CLICK HERE
          </Button> */}
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            // mt={2}
          >
            <Button
              onClick={() => {
                navigate(`/${businessName}/catalog`);
              }}
              sx={{
                boxShadow: "none",
                height: "auto",
                lineHeight: "21px",
                fontWeight: 600,
                padding: "4px 20px",
                background: `linear-gradient(to right, #424549 0%, #36393E 100%)`,
                color: whiteColor,
                borderRadius: "8px",
                border: "1px solid #000",
                fontSize: "11px",
                marginLeft: "10px",
                textTransform: "none",
                "&:hover": {
                  backgroundColor: { xs: whiteColor },
                  color: blackColor,
                },
                // textDecoration: 'underline',
              }}
            >
              Share & Earn
            </Button>
          </Box>
        </Box>
      </Box>
      <Box
        sx={styles.commissionCard}
        onClick={() => {
          // navigate('/affiliatePayments')
        }}
        gap={1}
        mt={1}
      >
        <Box
          component="img"
          src="https://storage.googleapis.com/bodefaults/shopweb/affiliates/commission-earnings.svg"
          alt="costbo"
          sx={{ width: "35px", height: "35px", objectFit: "contain" }}
        />
        <Box display="flex" flexDirection={"column"}>
          <Typography
            variant="h6"
            fontSize={11.5}
            fontWeight={500}
            lineHeight="18px"
            color={blackColor26}
          >
            Total Commission Earnings
          </Typography>
          <Typography
            variant="h6"
            fontSize={14}
            fontWeight={600}
            lineHeight="18px"
            color={blackColor}
          >
            ₹{" "}
            {pendingPayments && settledPayments
              ? Number(pendingPayments?.total + settledPayments?.total).toFixed(
                  2
                )
              : "0"}
          </Typography>
        </Box>
      </Box>
      {rellerProfileData &&
        !rellerProfileData?.details?.bankInfo?.accountNo && (
          <Box m="0 16px 10px">
            <Typography
              variant="body2"
              fontSize={11.5}
              fontWeight={500}
              lineHeight="18px"
              color={blackColor}
            >
              {userType === "guest" ? `Please ` : ""}
              {userType === "guest" && (
                <Typography
                  variant="body2"
                  component="a"
                  fontSize={12}
                  fontWeight={600}
                  color={orangeColor01}
                  sx={{
                    display: "inline",
                    textDecoration: "underline",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setShowRegisterInstr(true);
                  }}
                >
                  Register
                </Typography>
              )}
              {userType === "guest" ? (
                ` your account and Update your Banking details`
              ) : (
                <>
                  Update your{" "}
                  <Typography
                    variant="body2"
                    component="a"
                    fontSize={12.5}
                    fontWeight={600}
                    color={orangeColor01}
                    sx={{
                      display: "inline",
                      textDecoration: "underline",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      navigate(`/${businessName}/affiliateBankDetails`);
                    }}
                  >
                    Banking details
                  </Typography>
                </>
              )}{" "}
              for direct settlement in your account
            </Typography>
          </Box>
        )}
      <AffliatePaymentsContent
        fetchPendingPayments={fetchPendingPayments}
        fetchSettledPayments={fetchSettledPayments}
        affiliateCommissionPercentage={commissionPercentage}
      />
      <GuestRegisterInstructions
        open={showRegisterInstr}
        setOpen={setShowRegisterInstr}
      />
    </Box>
  );
}

export default AffiliateProgramsContent;

const styles = {
  costBoText: {
    color: orangeColor01,
    backgroundColor: whiteColor,
    borderRadius: "5px",
    padding: "6px 12px",
    border: "1.5px dashed " + orangeColor01,
  },

  commissionCard: {
    alignItems: "center",
    // justifyContent: 'space-between',
    margin: "14px 15px 10px",
    borderRadius: "6px",
    cursor: "pointer",
    display: "flex",
    position: "relative",
    alignItems: "center",
    background: bgColor17,
    marginTop: "5px",
    borderRadius: "10px",
    padding: "10px",
    border: "1px solid " + bgColor17,
  },

  exploreBtn: {
    fontSize: "13px",
    padding: "4px 12px",
    mt: 1.8,
  },
};
